/**
 * Request encoding. One of 'KVP', 'REST'.
 * @enum {string}
 */
var _ol_source_WMTSRequestEncoding_ = {
  KVP: 'KVP',  // see spec §8
  REST: 'REST' // see spec §10
};

export default _ol_source_WMTSRequestEncoding_;
